import { AxiosResponse } from "axios";
import { Endpoint } from "./util/contants";
import { SopDataModel, SopResponse } from "./responsePayload/SopResponse";
import {
  apiDeleteRequest,
  apiGetRequest,
  apiPatchRequest,
  apiPostRequest,
  createPayload,
} from "./util/apiUtils";

export const getSopKnowledge = async (
  endpoint: string | undefined = Endpoint.sop,
  pathVariables: Record<string, any> = {},
  queryParams: Record<string, any> = {},
  page: number | undefined = undefined
): Promise<SopResponse | undefined> => {
  const query = {
    ...queryParams,
    page: page,
  };

  const path = {
    ...pathVariables,
    id: undefined,
  };

  return await apiGetRequest<SopResponse>(endpoint, path, query);
};

export const getSopId = async (
  id: number | undefined = undefined
): Promise<SopDataModel | undefined> => {
  try {
    return await apiGetRequest<SopDataModel>(Endpoint.sop, {
      id: id,
    });
  } catch {
    return undefined;
  }
};

export const deleteSopKnowledge = async (
  id: number
): Promise<AxiosResponse | null> => {
  return await apiDeleteRequest(Endpoint.sop, {
    id: id,
  });
};

export const addSopKnowledge = async (
  title: string,
  description: string,
  content: string
): Promise<AxiosResponse | null> => {
  const basePayload = {
    title: title,
    description: description,
    content: content,
  };

  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.sopPost, payload);
};

export const editSopKnowledge = async (
  id: number,
  content: string,
  description?: string
): Promise<SopDataModel | null> => {
  const basePayload = {
    content: content,
    ...(description && { description: description }),
  };
  const payload = createPayload(basePayload);
  const response = await apiPatchRequest(Endpoint.sop, { id: id }, payload);

  return response as SopDataModel | null;
};
